export const DEFAULT_OPTIONS = {
  el: null,
  rate: null,
  size: 24,
  primaryColor: '#FFE135',
  secondColor: '#ddd'
}
